import $ from './jquery-2.2.0'
import $debounce from './jquery.debounce';

window.RadResponder = window.RadResponder || {};

export default function InitializeTimeoutPrompt(timeoutDuration, promptDuration) {
    RadResponder.Timeout = function (timeoutDurationArg, promptDurationArg) {
        if ((document.getElementById("timeoutDuration") === undefined || document.getElementById("timeoutDuration") === null) && !timeoutDurationArg) {
            return {
                process: function () { }
            };
        }

        var timer = null;
        var modalDomObject = null;
        var timeoutDuration = timeoutDurationArg || parseInt(document.getElementById("timeoutDuration").value);
        var promptDuration = promptDurationArg || parseInt(document.getElementById("promptDuration").value) + 5; //adding 5 seconds to ensure the session has expired

        var template =
            '<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-hidden="true"> \
                <div class="modal-dialog"> \
                    <div class="modal-content"> \
                        <div class="modal-header"> \
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> \
                            <h4 class="modal-title">Session Log Off</h4> \
                        </div> \
                        <div class="modal-body"> \
                            You are about to be logged off.  Would you like to maintain your session? \
                        </div> \
                        <div class="modal-footer"> \
                                <button type="button" class="btn btn-default" data-dismiss="modal">No</button> \
                                <button type="button" class="btn btn-primary" onclick="RadResponder.Timeout.stayAlive()">Yes</button> \
                        </div> \
                    </div> \
                </div> \
            </div>';


        //use localStorage and events to signal when new activity occurs to other open tabs/windows in current browser session
        var newActivityMessageKey = "new-activity";
        var signOnMessageKey = "sign-on";
        var signOffMessageKey = "sign-off";
        var allStorageMessages = [newActivityMessageKey, signOnMessageKey, signOffMessageKey];
        var broadcastNewActivity = function () {
            localStorage.setItem(newActivityMessageKey, JSON.stringify({ 'command': newActivityMessageKey, 'value': new Date() }));
            localStorage.removeItem(newActivityMessageKey);        
        };
        var broadcastSignOff = function () {
            localStorage.setItem(signOffMessageKey, JSON.stringify({ 'command': signOffMessageKey, 'value': new Date() }));
            localStorage.removeItem(signOffMessageKey);
        };
        var broadcastSignOn = function () {
            localStorage.setItem(signOnMessageKey, JSON.stringify({ 'command': signOnMessageKey, 'value': new Date() }));
            localStorage.removeItem(signOnMessageKey);
        };
        var receivedStorageBroadcast = function (ev) {
            if (!ev.originalEvent || ev.originalEvent.newValue === "" || allStorageMessages.indexOf(ev.originalEvent.key) < 0) {
                return; // ignore other keys
            }
            var message = JSON.parse(ev.originalEvent.newValue);
            if (!message) {
                return; // ignore empty msg or msg reset
            }

            switch (message.command) {
                case newActivityMessageKey:
                    //reset timer because new activity was encountered on another tab
                    process();
                    break;
                case signOnMessageKey:
                    setTimeout(function () {
                        //a different tab signed on, so try to refresh the page
                        var homeUrl = "/app/index";
                        if (window.location === homeUrl) {
                            window.location.reload(true);
                        } else {
                            window.location.assign(homeUrl);
                        }
                    }, 5000);
                    break;
                case signOffMessageKey:
                    //a different tab signed off, so redirect to the signed out page with the correct ReturnUrl
                    setTimeout(function () {
                        RadResponder.goToSignedOutPage();
                    }, 5000);
                    break;
            }
        };
        $(window).on("storage", receivedStorageBroadcast);



        var expiredEvent = function () {
            $(window).off("storage");

            var hash = window.location.hash.substr(1);
            broadcastSignOff(hash);
            location.href = RadResponder.getAddress() + "app/signout" + (hash ? "?returnUrl=" + hash : "");
        };

        //on expiration of the timer
        var promptEvent = function () {
            clearTimeout(timer);
            timer = setTimeout(expiredEvent, (promptDuration) * 1000);

            if (!modalDomObject) {
                modalDomObject = $(template);

                modalDomObject.appendTo(document.body)
                    .on("show.bs.modal", function () {
                        $(".modal:visible").not(modalDomObject).addClass("below-backdrop");
                    }).on("hide.bs.modal", function () {
                        $(".modal.below-backdrop").removeClass("below-backdrop");
                    }).on("hidden.bs.modal", function () {
                        modalDomObject.remove();
                        modalDomObject = null;
                    });
            }
            modalDomObject.modal("show");
        };

        var clearTimer = function () {
            clearTimeout(timer);
        };

        //runs every page load or ajax call
        var process = function () {
            clearTimeout(timer);
            if (modalDomObject) {
                modalDomObject.modal("hide");
            }

            //update the timeout duration in case it changed
            timeoutDuration = parseInt(document.getElementById("timeoutDuration")?.value || timeoutDurationArg);
            if (timeoutDuration === -1) {
                //timeoutDuration will be -1 if the user is not authenticated.
                return;
            }

            if (timeoutDuration && promptDuration) {
                var timeoutMs = (timeoutDuration - promptDuration) * 1000;
                if (timeoutMs > 0) {
                    timer = setTimeout(promptEvent, timeoutMs);
                }
            }
        };

        var stayAlive = function () {
            $.post(RadResponder.getApiAddress() + "account/ping", function () {
                modalDomObject.modal("hide");
            });
        };

        return {
            clearTimer: clearTimer,
            process: process,
            stayAlive: stayAlive,
            broadcastNewActivity: $debounce(500, broadcastNewActivity),
            broadcastSignOn: broadcastSignOn,
            broadcastSignOff: broadcastSignOff
        };
    }(timeoutDuration, promptDuration);
}

InitializeTimeoutPrompt();